import { useState } from "react";
import { useParams } from "react-router-dom";
import { authenticatedFetch } from '@/services/auth/authenticatedFetch.js';

export const useGetConsultantPayslip = ( ) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const [file, setFile] = useState(null);
  const { id: consultantUuid } = useParams();

  const getConsultantPayslip = async (payslipFileUuid) => {
    if (!consultantUuid) return;
    setLoading(true);
    setError(null);
    // console.log("getConsultantPayslip ", payslipFileUuid)

    try {
      const response = await authenticatedFetch(
        window.ENV.BACKEND_URL+`/api/secured/admin/payslip/payslipFile/${consultantUuid}/${payslipFileUuid}`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch payslip");
      }

    //   const fileBlob = await response.blob();
    //   setFile(fileBlob);


      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
    //   console.log("blob file payslip ", blob, url)

      setData({ url, type: blob.type });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { getPayslip :getConsultantPayslip, loading, error, data, refetch: getConsultantPayslip };
};
